import React from 'react';

export function CustomersColumnFormatter(cellContent) {

  const mappedCellContent = Array.isArray(cellContent) && cellContent.map((item, index) => {
    return (
      <div key={index} className="text-dark-75 font-weight-bolder d-block font-size-lg">
        {item.firstName} {item.lastName}
      </div>
    )
  });

  return (
    <div className="text-dark-75 font-weight-bolder d-block font-size-lg">
      {mappedCellContent}
    </div>
  );
}
